/* eslint-disable import/order */
import React, { useContext, useState } from 'react';
import { Button, Popover, Typography, useTheme } from '@mui/material';
import { number, shape, string } from 'prop-types';
import { useParams } from 'react-router-dom';
import * as R from 'ramda';

// Utils
import { DRAWER_TYPES } from 'utils/constants';
import newSelfAuthSteps from '../../create-new-steps/Steps';
import { DrawerContext } from 'common/drawer/DrawerContext';
import { setSelfAuthorizationDialogOpen } from '../../store/selfAuthorizationsSlice';
import { resetWizardData } from '../../store/createNewSelfAuthorizationSlice';

// Components
import Wizard from 'common/Wizard';
import FilterPopover from '../../filter-popover/FilterPopover.connector';

// Icons
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';

// Styles
import { filterCounterStyles } from '../CardsPanel.styles';
import { useUserRolePermissions } from 'hooks';

// Non-Primitives
// Defined outside of component to keep them from garbage collection on rerenders
const buttonsNewAuthorizationsStyles = { marginLeft: theme => theme.spacing(3) };

const HeaderButtons = ({ activeSelfAuthTab, filterIdentifierCount, selfAuthorizations }) => {
  const { setDrawerComponentProps } = useContext(DrawerContext);
  const { viewBy } = useParams();
  const { isProductLoadingManage } = useUserRolePermissions();
  const theme = useTheme();
  // an empty array is truthy, need to evaluate length of array
  const disableFilterButton = !selfAuthorizations[activeSelfAuthTab]?.length;

  const [filterAnchorEl, setFilterAnchorEl] = useState(null);

  return (
    <>
      <Button
        disabled={disableFilterButton}
        onClick={R.o(setFilterAnchorEl, R.prop('currentTarget'))}
        onClose={() => setFilterAnchorEl(null)}
        variant="text"
      >
        Filters
        {filterIdentifierCount >= 1 && (
          <Typography sx={filterCounterStyles(theme)}>{filterIdentifierCount}</Typography>
        )}
        {filterAnchorEl ? (
          <ExpandLessRoundedIcon position="right" variant="buttonsChild" />
        ) : (
          <ExpandMoreRoundedIcon position="right" variant="buttonsChild" />
        )}
      </Button>

      <Popover
        anchorEl={filterAnchorEl}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'bottom',
        }}
        disableScrollLock
        onClose={() => setFilterAnchorEl(null)}
        open={!!filterAnchorEl}
        transformOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
      >
        <FilterPopover />
      </Popover>
      {isProductLoadingManage && (
        <Button
          onClick={() =>
            setDrawerComponentProps({
              Component: props => (
                <Wizard steps={newSelfAuthSteps} title="New Self Authorizations" {...props} />
              ),
              forceCloseSelector: state => state.loadingManagement.createNewSelfAuth.forceClose,
              holdOpenSelector: state => state.loadingManagement.createNewSelfAuth.submittingBatch,
              resetWizard: () => resetWizardData(viewBy),
              setCurrentDialogOpen: setSelfAuthorizationDialogOpen,
              type: DRAWER_TYPES.createNewSelfAuth,
            })
          }
          sx={buttonsNewAuthorizationsStyles}
          variant="contained"
        >
          New Authorizations
        </Button>
      )}
    </>
  );
};

HeaderButtons.propTypes = {
  activeSelfAuthTab: string.isRequired,
  filterIdentifierCount: number.isRequired,
  selfAuthorizations: shape({}),
};

HeaderButtons.defaultProps = {
  selfAuthorizations: {},
};

export default HeaderButtons;
